import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue' // 登陆页面
import Index from '../views/Index.vue' // 右侧内容主页面

import Home from '../views/home/Home.vue' // 首页
import EquipList from '../views/home/EquipList.vue'
// 设备监测相关 start
import ProductionMonitor from '../views/monitor/production.vue' // 生产监测
import Shangq from '../views/monitor/shangq.vue' // 墒情监测
import Qix from '../views/monitor/qixiang.vue' // 气象监测
import Video from '../views/monitor/videos.vue' // 远程诊断
import Shuif from '../views/monitor/shuifei.vue' // 水肥监测
import Chongq from '../views/monitor/chongq.vue' // 虫情监测
import Performance from '../views/monitor/Performance.vue' // 设备执行情况
// 设备监测相关 end
import Warning from '@/views/warning/index.vue' // 告警信息
import Production from '../views/production/Production.vue' // 生产管理
import Task from '../views/task/Task.vue' // 任务管理
import Logging from '../views/logging/Logging.vue' // 日志记录
// 数据分析

// 综合分析
import EnvironChange from '../views/analysis/EnvironChange.vue' // 区域环境变化
import EnvironAnalysis from '../views/analysis/EnvironAnalysis.vue' // 环境参数分析
import QixAnalysis from '../views/analysis/QixAnalysis.vue' // 气象站数据分析
import LightAnalysis from '../views/analysis/LightAnalysis.vue' // 日光照分析
import RainFallAnalysis from '../views/analysis/RainFallAnalysis.vue' // 雨量累计分析

import other from '../views/task/other.vue' // 雨量累计分析

import videos from '../components/video.vue'
Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'login',
		component: Login,
		hidden: true,
	},
	{
		path: '/',
		component: Index,
		redirect: '/home',
		meta: { title: '首页' },
		children: [
			{
				path: 'home',
				component: Home,
				meta: { title: '首页', icon: 'home' },
			},
			{
				path: 'equipList',
				component: EquipList,
				meta: { title: '设备总数', activeMenu: '/home' },
				hidden: true,
			},
		],
	},
	// 设备监测
	{
		path: '/monitor',
		component: Index,
		meta: { title: '设备监测', icon: 'equipment' },
		children: [
			{
				path: 'production',
				component: ProductionMonitor,
				name: 'production',
				meta: { title: '生产监测' },
			},
			{
				path: 'shangqing',
				component: Shangq,
				name: 'shangqing',
				meta: { title: '墒情监测' },
			},
			{
				path: 'qix',
				component: Qix,
				name: 'qix',
				meta: { title: '气象监测' },
			},
			{
				path: 'videos',
				component: Video,
				name: 'videos',
				meta: { title: '远程诊断' },
			},
			{
				path: 'shuifei',
				component: Shuif,
				name: 'shuifei',
				meta: { title: '水肥监测' },
			},
			{
				path: 'chongq',
				component: Chongq,
				name: 'chongq',
				meta: { title: '虫情监测' },
			},
			{
				path: 'performance',
				component: Performance,
				name: 'performance',
				meta: { title: '设备执行情况' },
			},
		],
	},
	// 告警信息
	{
		path: '/warn',
		component: Index,
		children: [
			{
				path: '',
				component: Warning,
				name: 'warn',
				meta: { title: '告警信息', icon: 'warning' },
			},
		],
	},
	// 生产管理
	{
		path: '/production',
		component: Index,
		children: [
			{
				path: '',
				component: Production,
				name: 'production',
				meta: { title: '生产管理', icon: 'production' },
			},
		],
	},
	// 任务管理
	{
		path: '/task',
		component: Index,
		children: [
			{
				path: '',
				component: Task,
				name: 'task',
				meta: { title: '任务管理', icon: 'task' },
			},
		],
	},
	// 日志记录
	{
		path: '/logging',
		component: Index,
		children: [
			{
				path: '',
				component: Logging,
				name: 'logging',
				meta: { title: '日志记录', icon: 'log' },
			},
		],
	},
	// 综合分析
	{
		path: '/analysis',
		component: Index,
		meta: { title: '综合分析', icon: 'comprehensive' },
		children: [
			{
				path: 'aeraenviron',
				component: EnvironChange,
				name: 'production',
				meta: { title: '区域环境变化' },
			},
			{
				path: 'environ',
				component: EnvironAnalysis,
				name: 'environ',
				meta: { title: '环境参数分析' },
			},
			{
				path: 'qix',
				component: QixAnalysis,
				name: 'qixAnalysis',
				meta: { title: '气象站数据分析' },
			},
			{
				path: 'light',
				component: LightAnalysis,
				name: 'light',
				meta: { title: '日光照分析' },
			},
			{
				path: 'rainfall',
				component: RainFallAnalysis,
				name: 'rainfall',
				meta: { title: '雨量累计分析' },
			},
		],
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	// base: '/nywlw/',
	routes,
})

// 路由守卫设置
router.beforeEach((to, from, next) => {
	console.log(to)
	let toPath = to.path
	// 判断登陆信息不存在并且进入不是登录页，跳转到登录页面
	let token = window.localStorage.getItem('wlwtoken')
	if (toPath == '/login') {
		return next()
	}
	if (token && token != '') {
		return next()
	} else {
		return next('/login')
	}
})

export default router
